/**
 * This file defines the Program component, which serves as a container for displaying programming activity details and related issues.
 * The component renders the ProgrammingDetails component and the IssuesStudent component within tabs. Note that IssuesStudent is 
 * a placeholder component.
 */
import React from "react";
import ProgrammingDetails from "Screens1/Student/Course/Content/Programming/ComponentsNew/ProgrammingDetails/ProgrammingDetails.jsx";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import IssuesStudent from "Navigation/Course/Interactions/Issues/Student/issues.jsx";
import Countdown from "react-countdown";
import moment from "moment";
import countdownRenderer from "Components/Common/CountDownRenderer";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

function Program({
  programId,
  courseId,
  labID,
  activity_title,
  activity_description,
  AccessControlsProgActivity,
  ProgrammingActivityDetails,
  setAccessControlsProgActivity,
  studentData,
  isExam,
  provideAdditionalFiles,
  instructorAdditionalFiles,
  document,
  displayRunWithoutSubmitButton,
  handleTimeUp,
}) {
  const changeAccess = (update) => {
    setAccessControlsProgActivity(update);
  };

  const countdownKey = studentData?.end_time
    ? `cd-${new Date(studentData.end_time).getTime()}`
    : studentData?.start_time && studentData?.duration
      ? `cd-${new Date(studentData.start_time).getTime()}-${studentData.duration}`
      : 'cd-default';

  return (
    <div>
      {/* Tabs for displaying programming activity details and related issues */}
      <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example">
        <Tab eventKey="profile" title="Programming details">
          <div style={{ overflowX: "hidden" }}>
            <ProgrammingDetails
              programId={programId}
              activity_title={activity_title}
              activity_description={activity_description}
              details={ProgrammingActivityDetails}
              changeAccess={changeAccess}
              access={AccessControlsProgActivity}
              provideAdditionalFiles={provideAdditionalFiles}
              instructorAdditionalFiles={instructorAdditionalFiles}
              document={document}
              displayRunWithoutSubmitButton={displayRunWithoutSubmitButton}
            />
          </div>
        </Tab>
        <Tab eventKey="issues" title="Issues">
          <IssuesStudent />
        </Tab>
        <Tab
          title={
            isExam &&
              studentData &&
              studentData.start_time &&
              !studentData.is_finished ? (
              <>
                {
                  (studentData?.end_time) ? <Countdown
                    key={countdownKey}
                    date={
                      new Date(studentData.end_time).getTime()
                    }
                    onComplete={() => handleTimeUp()}
                    renderer={countdownRenderer}
                  />
                    : <Countdown
                      key={countdownKey}
                      date={
                        new Date(studentData.start_time).getTime() +
                        moment.duration(studentData.duration).asMilliseconds()
                      }
                      onComplete={() => handleTimeUp()}
                      renderer={countdownRenderer}
                    />
                }
              </>
            ) : null
          }
        ></Tab>
      </Tabs>
    </div>
  );
}

export default Program;
